<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {
	page: {
		title: 'Мой профиль',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: 'Мой профиль',
			items: [],
            phone: '',
            email: '',
            name1: '',
            name2: '',
            name3: '',
            isSubmitError: null,
            alertMessage: null,
            alertVariant: null,
		}
	},
	computed: {
        session_user_profile_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user.profile;
        },
	},
	async mounted() {

	    let profile = this.session_user_profile_item;

        this.name1 = profile.name1;
        this.name2 = profile.name2;
        this.name3 = profile.name3;

	},
	methods: {

        async resetAlerts(){
            this.isSubmitError = null;
            this.alertMessage = null;
            this.alertVariant = null;
        },

        async saveProfile(){

            let data_send = {
                'uuid'  : this.session_user_profile_item.uuid,
                'name1' : this.name1,
                'name2' : this.name2,
                'name3' : this.name3,
            };

            let result = '';

            result = await this.$store.dispatch('profiles/FETCH_PROFILES_UPDATE', data_send);
            if(result === false){
                this.isSubmitError = true;
                this.alertMessage = 'При обновлении данных возникла ошибка';
                this.alertVariant = 'danger';
            } else {
                this.isSubmitError = true;
                this.alertMessage = 'Информация успешно обновлена';
                this.alertVariant = 'success';
            }

        }
	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveProfile"
            @click="resetAlerts"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <b-alert
                            v-model="isSubmitError"
                            :variant="alertVariant"
                            dismissible
                        >{{ alertMessage }}</b-alert
                        >

                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Фамилия"
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="name3"
                                            v-model="name3"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Имя"
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="name1"
                                            v-model="name1"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Отчество"
                                        label-for="input-horizontal"
                                    >
                                        <b-form-input
                                            id="name2"
                                            v-model="name2"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
